/*
 * Copyright (c) 2024-2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

export class FieldRule {
    fieldName: string;
    required: boolean;
    // This used to be a boolean until we realized some fields are unique on their own
    // and some objects are made unique by combination of fields
    // ex 1: ID is always a unique field -> 'id'
    // ex 2: model year + program combination must be unique -> 'modelYearProgram'
    // ex 3: ring terminal gm part number must always be unique -> 'gmPartNumber'
    uniqueFieldSetName?: string;
    // For numeric fields, this is really max value
    // For string fields, this is max character length and should match db column
    maxLength: number;
    minLength?: number;
    pattern?: string | RegExp;
    patternName?: string;
    type?: string;
    allowedValueKey?: string;
    allowsBlankValue?: boolean;
    // True only when this field's own allowedValues contains a real DB-backed reference option
    // (a positive id) whose display value (via allowedValueKey) is blank - e.g. RingTerminal's
    // Plating id=41 resolves to plating: "". Unlike allowsBlankValue (which governs "no value at
    // all" cases such as YesOrNoOrBlank), this is narrowly scoped per-field so it never suppresses
    // required/pattern validation on other reference columns whose own data has no such entry.
    allowsBlankIdBackedReference?: boolean;
    forErrorMessage?: string;
}

export class GridModel {
    fieldRules = new Array<FieldRule>();
    originalRowData?: ValidationModel;
    changes = new Map();
    state: 'new' | 'deleted' | 'changed' | 'saved' = 'saved';
}

export class ValidationModel extends GridModel {
    rowNumber: number;
}
